const OFFICIAL = [
  "域名主体完整、拼写规范，路径层级清晰",
  "全程启用 HTTPS，地址栏可看到安全锁标识",
  "页脚能查到运营主体与备案信息",
  "入口多来自官网、官方应用商店或可信搜索结果",
  "内容更新稳定，有明确版块与长期运营痕迹",
  "仅索要账号使用所需的最基本信息",
  "更新或升级均在站内完成，不要求另装软件",
];

const FAKE = [
  "域名混入数字、符号、前后缀，与官方仅差一字",
  "无加密或证书异常，浏览器提示“不安全”",
  "页脚缺失主体与备案，或信息反复变动",
  "多经群聊、短信、弹窗或陌生链接跳转而来",
  "内容拼凑、版块残缺，发布时间与页面不符",
  "反复索取手机号、银行卡与验证码",
  "诱导下载 App 或压缩包，要求私下转账",
];

export default function Compare() {
  return (
    <section id="compare" className="scroll-mt-20">
      <div className="wrap py-10 md:py-14">
        <div className="mx-auto max-w-2xl text-center">
          <p className="kicker mb-3">
            <i className="ri-git-merge-line"></i>
            官方 vs 仿冒对照
          </p>
          <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">七个维度，快速分清正规站与仿冒站</h2>
          <p className="mt-3 text-[15px] leading-7 text-foreground-700">
            不要只看 Logo 是否像，也别只听“我是官方”。把访问入口、域名与页面行为放到下表逐项比对，结论会更可靠。
          </p>
        </div>

        <div className="mt-9 grid gap-5 lg:grid-cols-2">
          <article className="rounded-lg border border-secondary-200 bg-secondary-50 p-6">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-500 text-background-50">
                <i className="ri-check-double-line text-lg"></i>
              </span>
              <h3 className="font-heading text-xl text-secondary-900">更像正规站的特征</h3>
            </div>
            <ul className="mt-5 space-y-3">
              {OFFICIAL.map((t) => (
                <li key={t} className="flex items-start gap-2.5 text-sm leading-6 text-foreground-800">
                  <i className="ri-checkbox-circle-line mt-0.5 text-secondary-600"></i>
                  <span>{t}</span>
                </li>
              ))}
            </ul>
          </article>

          <article className="rounded-lg border border-primary-200 bg-primary-50 p-6">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-close-circle-line text-lg"></i>
              </span>
              <h3 className="font-heading text-xl text-primary-900">更像仿冒站的特征</h3>
            </div>
            <ul className="mt-5 space-y-3">
              {FAKE.map((t) => (
                <li key={t} className="flex items-start gap-2.5 text-sm leading-6 text-foreground-800">
                  <i className="ri-close-circle-fill mt-0.5 text-primary-500"></i>
                  <span>{t}</span>
                </li>
              ))}
            </ul>
          </article>
        </div>

        <div className="mt-6 flex flex-col items-start gap-3 rounded-lg border-l-4 border-accent-500 bg-accent-100/70 p-5 sm:flex-row sm:items-center">
          <i className="ri-lightbulb-flash-line text-2xl text-accent-700"></i>
          <p className="text-sm leading-6 text-foreground-800">
            <strong className="font-semibold text-foreground-950">判断原则：</strong>
            单项信号只能做参考，建议多个维度同时验证。只要域名或要求“私下转账、下载安装包、索要验证码”任何一项踩雷，就应立刻停止操作。
          </p>
        </div>
      </div>
    </section>
  );
}